import auth from './auth';

const redirectToDashboard = (nextState, replace) => {
  const query = nextState.location && nextState.location.query;
  const token = query && query.token;

  if (token) {
    const home = token
      ? `home?token=${token}`
      : 'home';
    replace(home);
  } else if (auth.loggedIn()) {
    replace('/dashboard');
  }
};

export default redirectToDashboard;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/utils/redirectToDashboard.js
 **/